/* eslint-disable @typescript-eslint/no-misused-promises */
import { GoogleLogin } from "@react-oauth/google"
import { setAuth } from "./authSlice"
import { useAppDispatch } from "@/app/hooks"
import { baseUrl } from "@/lib/utils"
import { resetHome } from "../home/homeSlice"

type GoogleAuthResponse = {
  token: string
}

export const Login = () => {
  const dispatch = useAppDispatch()

  return (
    <GoogleLogin
      onSuccess={async credentialResponse => {
        const idToken = credentialResponse.credential
        if (!idToken) return

        // Send to your backend
        const res = await fetch(baseUrl + "/auth/google", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ token: idToken }),
        })

        const data = (await res.json()) as GoogleAuthResponse

        dispatch(setAuth({ token: data.token }))
        dispatch(resetHome())
        // window.location.href = "/"
      }}
      onError={() => {
        console.error("Login Failed")
      }}
    />
  )
}
